import React, { useState, useEffect } from "react";
import { Box, Modal } from "@mui/material";
import { useUser } from "../../../context/useUser";
import IslamiBank from "../../../assets/images/islamiBank.png";
import AlliedBank from "../../../assets/images/AlliedBank.png";
import FaysalBank from "../../../assets/images/FaysalBank.png";
import BOPBank from "../../../assets/images/BopBank.png";

const Advertise = () => {
  const [open, setOpen] = useState(false);
  const { country } = useUser();

  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem("hasSeenModal");
    if (!hasSeenModal) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    sessionStorage.setItem("hasSeenModal", "true");
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      }}
    >
      <Box
        sx={{
          width: "90%",
          maxWidth: "500px",
          maxHeight: country === "PK" ? "90vh" : "80vh", // relative to screen
          margin: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 24,
          borderRadius: 3,
          overflowY: "auto", // allow scroll if needed
          backdropFilter: "blur(10px)",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          p: { xs: 2, sm: 4 }, // responsive padding
        }}
      >
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            color: "#5c4033",
            textAlign: "center",
            width: "100%",
          }}
        >
          <h1 className="text-white font-[700] text-2xl sm:text-3xl">Dear Customer!</h1>

          {country === "PK" && (
            <h2 className="text-white font-medium text-base sm:text-lg mt-3 leading-relaxed">
              Flat{" "}
              <span className="font-bold text-lg sm:text-xl text-yellow-300">
                15% Off
              </span>{" "}
              on all Qurbani bookings for bank customers,
              <span className="font-bold mt-3 bg-white items-center opacity-40 px-4 grid grid-cols-1 sm:grid-cols-2 gap-3 ml-1 text-[15px] sm:text-[17px] text-black">
                <div className="flex gap-2 items-center">
                  <img src={IslamiBank} className="h-[40px] sm:h-[60px]" />
                  <p>Bank Islami</p>
                </div>
                <div className="flex gap-2 items-center">
                  <img src={AlliedBank} className="h-[35px] sm:h-[50px]" />
                  <p>Allied Bank</p>
                </div>
                <div className="flex gap-2 items-center">
                  <img src={FaysalBank} className="w-[60px] sm:w-[80px]" />
                  <p>Faysal Bank</p>
                </div>
                <div className="flex gap-2 items-center">
                  <img src={BOPBank} className="h-[40px] sm:h-[60px]" />
                  <p>Bank of Punjab</p>
                </div>
              </span>
            </h2>
          )}

          <h2 className="text-white text-base sm:text-lg font-medium leading-relaxed mt-3">
            We currently deliver only in{" "}
            <span className="text-white font-[700] text-xl sm:text-2xl">
              {country === "PK"
                ? '"Lahore"'
                : '"regions within Pennsylvania, New Jersey, New York City (& surrounding boroughs), and Delaware"'}
            </span>{" "}
            to ensure top-notch freshness!
          </h2>

          <br />
          <h1 className="text-white font-[700] text-2xl sm:text-3xl">&</h1>

          <h2 className="text-white text-base sm:text-lg font-medium leading-relaxed mt-3 mb-6">
            We accept donations all over the{" "}
            <span className="text-white font-[700] text-xl sm:text-2xl">
              "World"
            </span>{" "}
            Every donation is a step toward a world full of smiles!
          </h2>

          <button
            onClick={handleClose}
            className="px-6 sm:px-8 py-2 bg-[#8a2e25] text-[14px] sm:text-[15px] font-[500] text-white rounded-[5px]"
          >
            Enter
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default Advertise;
